import { render, staticRenderFns } from "./AuctionRuntimeData.vue?vue&type=template&id=05acde6e&"
import script from "./AuctionRuntimeData.vue?vue&type=script&lang=js&"
export * from "./AuctionRuntimeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports